export const RE_CALL = {
  YES: 1,
  NO: 0,
};
